export const gitCommit = '82acd3e1'
